




















































































import url from "url";
import { Component, Prop, Vue } from "vue-property-decorator";

import { ArrowRight } from "@/components/icons";
import { qSet } from "@/services/utils";

@Component({
  name: "Pagination",
  components: {
    Right: ArrowRight,
  },
})
export default class Pagination extends Vue {
  @Prop({ type: Number, default: 1 })
  readonly current_page!: number;

  @Prop({ type: Number, default: 1 })
  readonly total_pages!: number;

  @Prop({ type: Number, default: 5 })
  readonly max!: number;

  @Prop({ type: String, default: "page" })
  readonly getParam!: string;

  @Prop({ type: Function, default: () => null })
  readonly routeHandler!: (page: number) => void;

  get visible() {
    if (this.total_pages > 5) {
      if (this.current_page <= 3) {
        return 4;
      } else if (this.total_pages - this.current_page <= 2) {
        return [
          this.total_pages - 3,
          this.total_pages - 2,
          this.total_pages - 1,
          this.total_pages,
        ];
      } else {
        return [
          this.current_page - 1,
          this.current_page,
          this.current_page + 1,
        ];
      }
    } else {
      return this.total_pages;
    }
  }

  getPath(page: number) {
    const { query, path } = this.$route;
    const q = qSet(this.getParam, page, query) as { [key: string]: string };
    return url.format({
      pathname: path,
      query: q,
    });
  }
}
